import axios from '../axiosConfig.jsx'

export default async function getLocations(clientId) {
    return await axios.get(`/partners/locationsForPickup?ClientId=${clientId}`).then(res => res.data)
}